import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import NextQuestionButton from '../NextQuestionButton';
import CameraIcon from '../../ui/icons/CameraIcon';
import styled from 'styled-components';
import Button from '../../ui/Button';
import { Flex } from '../../ui/Flex';
import UploadFile from '../../ui/fields/input/UploadFile';
import { Field } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectRegister,
    setBackIdImage,
    setBackIdUrl,
    setCurrentQuestion,
} from '../../../store/reducers/registerSlice';
import CaptureImage from './CaptureImage';
import { base64ToFile } from '../../../utils/base64ToFile';
import EditImage from './EditImage';
import { useTranslation } from 'react-i18next';
import { useUploadFileMutation } from '../../../store/RTKQuery/upload/uploadFile';
import { questions } from '../Register';
import ImageInstructions from '../../ui/ImageInstructions';

const Question8BackIdStyle = styled.div`
    h3.title {
        margin-bottom: 5px !important;
    }
`;

interface IProps {}

const Question8BackId: FC<IProps> = () => {
    const dispatch = useDispatch();
    const { backIdImage, backIdUrl } = useSelector(selectRegister);
    const [isCaptureImageNow, setIsCaptureImageNow] = useState<Boolean>(false);
    const [isEditImageNow, setIsEditImageNow] = useState<Boolean>(false);
    const { t } = useTranslation();
    const [uploadImage, { data, isLoading, isSuccess }] =
        useUploadFileMutation();
    const nextPageNumber: number = 9;
    const goToNextPage = () => {
        dispatch(
            setCurrentQuestion(
                questions.filter((q) => q.page === nextPageNumber)[0],
            ),
        );
    };
    useEffect(() => {
        if (isSuccess && data) {
            dispatch(setBackIdUrl(data.file_path));
            goToNextPage();
        }
    }, [isSuccess]);
    return (
        <Question8BackIdStyle>
            <h3 className="title">{t('imageOfTheBackOfYourID')}</h3>
            {!isCaptureImageNow && (
                <p className={'subtitle'}>
                    {t('makeSureItMatchesTheDetailsYouProvidedEarlier')}
                </p>
            )}
            <Flex direction={'column'} alignItems={'center'}>
                {!backIdImage.original ? (
                    <>
                        {!isCaptureImageNow ? (
                            <>
                                <button
                                    className={'capture'}
                                    type={'button'}
                                    onClick={() => {
                                        setIsCaptureImageNow(true);
                                    }}
                                >
                                    <CameraIcon />
                                </button>
                                <p className={'captureWithPhoneCamera'}>
                                    {t('captureWithPhoneCamera')}
                                </p>
                                <p className="or">{t('or')}</p>
                                <Field
                                    name={'back_id_imageFormData'}
                                    text={t('uploadImage')}
                                    className={'uploadImage'}
                                    onChange={(
                                        event: ChangeEvent<HTMLInputElement>,
                                    ) => {
                                        if (event.currentTarget.files) {
                                            dispatch(
                                                setBackIdImage({
                                                    original:
                                                        event.currentTarget
                                                            .files[0],
                                                    upload: event.currentTarget
                                                        .files[0],
                                                }),
                                            );
                                        }
                                    }}
                                    component={UploadFile}
                                />
                            </>
                        ) : (
                            <CaptureImage
                                cameraType={'environment'}
                                onCapture={(imageSrc) => {
                                    dispatch(
                                        setBackIdImage({
                                            original: base64ToFile(
                                                imageSrc,
                                                'BackIdImage',
                                            ),
                                            upload: base64ToFile(
                                                imageSrc,
                                                'BackIdImage',
                                            ),
                                        }),
                                    );
                                    setIsCaptureImageNow(false);
                                }}
                                onBack={() => {
                                    setIsCaptureImageNow(false);
                                }}
                            />
                        )}{' '}
                    </>
                ) : (
                    <>
                        {isEditImageNow && backIdImage.original ? (
                            <EditImage
                                onEdit={(imageSrc) => {
                                    dispatch(
                                        setBackIdImage({
                                            original: backIdImage.original,
                                            upload: base64ToFile(
                                                imageSrc,
                                                'BackIdImage',
                                            ),
                                        }),
                                    );
                                    dispatch(setBackIdUrl(''));
                                    setIsEditImageNow(false);
                                }}
                                image={backIdImage.original}
                                onBack={() => {
                                    setIsEditImageNow(false);
                                }}
                            />
                        ) : (
                            <>
                                {backIdImage.upload && (
                                    <img
                                        src={URL.createObjectURL(
                                            backIdImage.upload,
                                        )}
                                        alt=""
                                        className={'imagePreview'}
                                    />
                                )}
                                {/*  <Flex
                                    alignItems={'center'}
                                    gap={10}
                                    className={'imageEditActions'}
                                    marginBottom={20}
                                >
                                    <button
                                        type={'button'}
                                        onClick={() => {
                                            setIsEditImageNow(true);
                                        }}
                                    >
                                        <CropIcon />
                                    </button>
                                    <button
                                        type={'button'}
                                        onClick={() => {
                                            setIsEditImageNow(true);
                                        }}
                                    >
                                        <RotateIcon />
                                    </button>
                                </Flex>*/}

                                <div className={'uploadImageConfirmActions'}>
                                    <Button
                                        text={t('captureAgain') || ''}
                                        variant={'outline'}
                                        handleClick={() => {
                                            dispatch(
                                                setBackIdImage({
                                                    original: null,
                                                    upload: null,
                                                }),
                                            );
                                            dispatch(setBackIdUrl(''));
                                        }}
                                    />
                                    <NextQuestionButton
                                        canNext={true}
                                        nextPage={nextPageNumber}
                                        text={t('yesContinue') || ''}
                                        isLoading={isLoading}
                                        onClick={() => {
                                            if (!backIdUrl) {
                                                const formData = new FormData();
                                                formData.append(
                                                    'file',
                                                    backIdImage.upload as File,
                                                );
                                                uploadImage(formData);
                                            } else {
                                                goToNextPage();
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        )}
                    </>
                )}
                {!isCaptureImageNow && <ImageInstructions />}
            </Flex>
        </Question8BackIdStyle>
    );
};
export default Question8BackId;
